import logo from './logo_white.png';

export const settings = {
    "title": "Marzorati CRM",
    "apiUrl": "https://api.marzorati.geniuscloud.it/api",
    "ckdPath": "https://api.marzorati.geniuscloud.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    //"googleMapKey": "AIzaSyB0JItfx2zvDnKkmxIBt_wru36tOVcx1iM",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Marzorati Centro Della Cameretta S.r.l. Con Socio Unico',
        "address": 'Via Donizetti, 13 - 22063 Cantù (CO)',
        "phone": 'Tel: 031 730053',
        "fax": 'Fax: 031 731121',
        "email": 'Email: info@marzoraticamerette.com',
        "iva": 'P.IVA: IT00311770135',
        "cf": '',
        "website": 'Sito Web: www.marzoraticasa.it',
    },
    "stampe" : {
       "arredatore": false, 
       "sconto": true, 
       "listino": true, 
       "condVendita": false, 
       "firmaVenditore": false
    },
    "dati_pagamento": {
        "iban": "IT23Q0843051061000000004407",
        "banca": "CASSA RURALE ED ARTIGIANA DI CANTU' BANCA DI CREDITO COOPERATIVO",
        "intestatario": "Marzorati Centro Della Cameretta S.r.l.",
    },
    "dati_fattura": {
        "statoPIVA": "IT",
        "PIVA": "03490440264",
        "PIVAcompleta": "IT03490440264",
        "regimeFiscale": "RF04",
        "numeroREA": "",
        "socioUnico": "",
        "statoLiquidazione": "",
        "ufficio": "",
        "indirizzo": "Corte delle Rose, 8",
        "cap": "31015",
        "comune": "Conegliano",
        "nazione": "IT",
        "provincia": "TV",
        "formatoTrasmissione": "FPR12",
        "codiceDestinatario": "A4707H7",
        "denominazione": "Prelude Advertising",
    },
    "iva_label": 'esclusa',
    "iva_esclusa": true,
    "sconti": true
}